module.exports = __webpack_public_path__ + "img/20190928142924360截图20190928132343849.bebc70c6.jpg";